export function extractValidationErrors(error: unknown): Array<{ field: string; errorMessage: string }> | null {
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as Record<string, unknown>).response
    if (response && typeof response === 'object' && 'data' in response) {
      const data = (response as Record<string, unknown>).data
      if (Array.isArray(data) && data.length > 0) {
        return data as Array<{ field: string; errorMessage: string }>
      }
      if (data && typeof data === 'object' && 'errors' in data) {
        const errors = (data as Record<string, unknown>).errors
        if (Array.isArray(errors) && errors.length > 0) {
          return errors as Array<{ field: string; errorMessage: string }>
        }
      }
    }
  }
  return null
}

export function extractChainRunId(error: unknown): string | null {
  const data = (error as { response?: { data?: { chainRunId?: string | null } } })?.response?.data
  return typeof data?.chainRunId === 'string' && data.chainRunId !== '' ? data.chainRunId : null
}

export function extractValidationMessage(error: unknown): string | null {
  const errors = extractValidationErrors(error)
  if (errors && errors.length > 0 && typeof errors[0]?.errorMessage === 'string') {
    return errors[0].errorMessage
  }
  return null
}

export function extractValidationMessages(error: unknown): string[] {
  const errors = extractValidationErrors(error)
  if (!errors) return []
  return errors
    .map(e => e.errorMessage)
    .filter((m): m is string => typeof m === 'string' && m.length > 0)
}

export function hasValidationError(error: unknown, field: string): boolean {
  const errors = extractValidationErrors(error)
  return errors?.some(e => e.field === field) ?? false
}

export function getValidationErrorMessage(error: unknown, field: string): string | null {
  const errors = extractValidationErrors(error)
  return errors?.find(e => e.field === field)?.errorMessage ?? null
}

